import { useEffect, useState } from "react";
import { filterConstants } from "../../constants";
import { subscriptionStatus } from "../../enums";
import { useQueryString } from "../../hooks";

import {
  ISubscription,
  IQueryStringNavLinks,
  ITableHeader,
} from "../../interfaces-and-types";
import { subscriptionsData } from "../../test-data";
import { View } from "./View";

export interface ISubscriptionsViewProps {
  data: ISubscription[];
  headers: ITableHeader[];
  isLoading: boolean;
  isError: boolean;
  totalCount: number;
  queryStringTabs: IQueryStringNavLinks;

  // modals
  isCreateNewModalOpen: boolean;
  closeModal: () => void;

  // extra buttons
  onExport: () => void;
  openCreateNewModal: () => void;
}

export const Subscriptions = () => {
  const [isCreateNewModalOpen, setCreateNewModalOpen] = useState(false);
  const closeModal = () => {
    setCreateNewModalOpen(false);
  };

  const [isLoading, setisLoading] = useState(true);

  const query = useQueryString();
  const status = query.get(filterConstants.statusKey);

  useEffect(() => {
    setTimeout(() => setisLoading(false), 500);
  }, []);

  const headers: ITableHeader[] = [
    {
      key: "customer",
      header: "Customer",
    },
    {
      key: "status",
      header: "Status",
    },
    {
      key: "billing_method",
      header: "Billing Method",
    },
    {
      key: "product",
      header: "Products",
    },
    {
      key: "date",
      header: "Date",
    },
    {
      key: "more",
      header: "",
    },
  ];

  const queryStringTabs: IQueryStringNavLinks = {
    query: filterConstants.statusKey,
    options: [
      {
        key: "All",
        value: "",
      },
      {
        key: "Active",
        value: "active",
      },
      {
        key: "Scheduled",
        value: "scheduled",
      },
      {
        key: "Cancelled",
        value: "cancelled",
      },
    ],
  };

  const queryFilteredData = subscriptionsData.filter(
    (tx) =>
      !status ||
      status === "all" ||
      subscriptionStatus[tx.status] === status ||
      (status === "scheduled" &&
        (tx.status === subscriptionStatus.active ||
          tx.status === subscriptionStatus.overdue))
  );

  const onExport = () => {
    // export data via api and download
    alert("exporting data...");
  };

  const openCreateNewModal = () => {
    // openModal
    setCreateNewModalOpen(true);
  };

  return (
    <View
      data={queryFilteredData}
      headers={headers}
      isLoading={isLoading}
      isError={false}
      totalCount={queryFilteredData.length}
      queryStringTabs={queryStringTabs}
      onExport={onExport}
      openCreateNewModal={openCreateNewModal}
      isCreateNewModalOpen={isCreateNewModalOpen}
      closeModal={closeModal}
    />
  );
};
